import { render, staticRenderFns } from "./ModalConfigureSign.vue?vue&type=template&id=65ec3edc&scoped=true&"
import script from "./ModalConfigureSign.vue?vue&type=script&lang=js&"
export * from "./ModalConfigureSign.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfigureSign.vue?vue&type=style&index=0&id=65ec3edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec3edc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ec3edc')) {
      api.createRecord('65ec3edc', component.options)
    } else {
      api.reload('65ec3edc', component.options)
    }
    module.hot.accept("./ModalConfigureSign.vue?vue&type=template&id=65ec3edc&scoped=true&", function () {
      api.rerender('65ec3edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalConfigureSign.vue"
export default component.exports